import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';

import { USER_ACTIONS } from '@legacy-redux/auth/actions';
import { selectUser } from '@legacy-redux/auth/selectors';

import { LanguageSelector } from '@shared/layout/components/LanguageSelector';
import { Icon } from '@shared/ui/components/Icon';
import { Modal, ModalContent } from '@shared/ui/components/Modal';
import { ModalTrigger } from '@shared/ui/components/Modal/ModalTrigger';
import { cn } from '@shared/utils/helpers';
import { PropsWithClassName } from '@shared/utils/types';

export function ServiceMenu({ className }: PropsWithClassName) {
  const dispatch = useDispatch();

  const location = useLocation();

  const user = useSelector(selectUser);

  const userInitials = user.firstName[0] + user.lastName[0];

  function logout() {
    dispatch(USER_ACTIONS.logoutRequest());
  }

  return (
    <Modal>
      <ModalTrigger className={cn('bg-teal-400 text-white font-medium rounded-full size-10 outline-none', className)}>
        {userInitials}
      </ModalTrigger>
      <ModalContent withCloseButton>
        {({ close }) => (
          <>
            <div className="bg-teal-400 text-white -mx-6 -mt-6 pt-12 pb-4 px-6 text-4xl font-bold">{userInitials}</div>
            <p className="text-gray-600">Logged in as {user.fullName}.</p>
            <p>
              <Link to="/profile" onClick={close} className="no-underline">
                <Icon icon="user" className="inline-block w-8" />
                <span className="underline text-blue-800 ml-1">Edit profile</span>
              </Link>
            </p>
            {!location.pathname.startsWith('/admin') && (
              <p>
                <Icon icon="flag" className="inline-block w-8" />
                <LanguageSelector />
              </p>
            )}
            <div className="mt-6 flex items-end justify-end text-sm">
              <span className="mr-auto text-gray-400">&copy; {new Date().getFullYear()} — WEAREONE.world</span>
              <button onClick={logout} className="inline-block underline text-gray-500">
                Log out
              </button>
              <span className="mx-2 text-gray-400">|</span>
              <a
                href="https://cas.api.tomorrowland.com/media/495375/TLBE_Privacy-Policy-CAS-ENG.pdf"
                className="inline-block underline text-gray-500"
              >
                Privacy policy
              </a>
            </div>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}
